import {Injectable} from '@angular/core';
import {
    CanActivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    UrlTree
} from '@angular/router';

import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import * as EmployeeModels from '@employee-models/index';
import {LocalStorageService} from '@ui-app/services/local-storage.service';
import {UserProfileService} from '@ui-app/services/user-profile.service';


@Injectable({
    providedIn: 'root'
})
export class AuthenticationGuard implements CanActivate {
    //   routesConfig: EmployeeModels.CM.KeyValue = RoutesConfig;

    constructor(
        private localStorageService: LocalStorageService,
        private userProfileService: UserProfileService,
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):
        Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        const impersonateToken: string = this.localStorageService.getItem('impersonateToken');
        if (!impersonateToken) {
            // this.businessService.adalService.handleCallback();
            const params = route.queryParams;
            const redirectUrl = this.localStorageService.getItem(EmployeeModels.CE.StorageKeys.RedirectUrl);
            /*   if (params.hasOwnProperty(Models.CE.QueryParams.Wlid) && !redirectUrl) {
                   // tslint:disable-next-line:max-line-length
                   const url = ``;
                   this.businessService.localStorageService.setItem(Models.CE.StorageKeys.RedirectUrl, url);
               }*/
            /*            if (!this.businessService.adalService.isAuthenticated) {
                            //   this.businessService.adalService.login();
                        }
                        console.log(this.businessService.adalService.accessToken);
                        this.businessService.localStorageService.setItem('accessToken', this.businessService.adalService.accessToken);*/
        }

        /*  if (state.url.indexOf(`${this.routesConfig.guests_new.guests}/${this.routesConfig.guests_new.profile}`) !== -1) {
              localStorage.setItem(EmployeeModels.CE.StorageKeys.redirectPathname, state.url);
          }*/

        if (!this.userProfileService.user) {
            return this.userProfileService.getUserData().pipe(
                map((user: EmployeeModels.DM.IUserData) => {
                    if (user && !(user.userRoleIds?.length ? user.userRoleIds : [user.userRoleId]).includes(EmployeeModels.DE.UserRoleEnum.PreHire)) {
                        return true;
                    } else {
                        window.location.assign(`https://${window.location.host}/prehire/index.html`);
                    }
                    return false;
                })
            );
        } else {
            return true;
        }

    }
}
